module.exports = __webpack_public_path__ + "/static/assets/a4834d0afbbe9fba0478d074c1bbe5e7.png";